import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import {
  ErrorBoundaryActionsWrapper,
  ErrorBoundaryAdminText,
  ErrorBoundaryContainer,
  ErrorBoundaryContent,
  ErrorBoundaryErrorCard,
  ErrorBoundaryErrorMessageBox,
  ErrorBoundaryErrorMessageText,
  ErrorBoundaryHeader,
  ErrorBoundaryHeading,
  ErrorBoundaryLogo,
  ErrorBoundaryMaxWidthWrapper,
  ErrorBoundaryMessageText,
  ErrorBoundaryRefreshIcon,
  ErrorBoundaryRetryButton,
} from './styled'

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: null,
  }

  static getDerivedStateFromProps(props, state) {
    if (props.routerError && !state.hasError) {
      return {
        hasError: true,
        error: props.routerError,
      }
    }
    return null
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught:', error, errorInfo)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  render() {
    const { t } = this.props

    if (this.state.hasError) {
      return (
        <ErrorBoundaryContainer>
          <ErrorBoundaryMaxWidthWrapper>
            <ErrorBoundaryErrorCard>
              <ErrorBoundaryHeader>
                <ErrorBoundaryLogo />
                <ErrorBoundaryHeading>
                  {t('errorBoundary.heading')}
                </ErrorBoundaryHeading>
              </ErrorBoundaryHeader>

              <ErrorBoundaryContent>
                <div>
                  <ErrorBoundaryMessageText>
                    {t('errorBoundary.message')}
                  </ErrorBoundaryMessageText>
                  <ErrorBoundaryErrorMessageBox>
                    <ErrorBoundaryErrorMessageText>
                      {t('errorBoundary.defaultError')}
                    </ErrorBoundaryErrorMessageText>
                  </ErrorBoundaryErrorMessageBox>
                </div>

                <ErrorBoundaryActionsWrapper>
                  <ErrorBoundaryRetryButton onClick={this.handleReset}>
                    <ErrorBoundaryRefreshIcon />
                    {t('errorBoundary.retryButton')}
                  </ErrorBoundaryRetryButton>

                  <ErrorBoundaryAdminText>
                    {t('errorBoundary.adminText')}
                  </ErrorBoundaryAdminText>
                </ErrorBoundaryActionsWrapper>
              </ErrorBoundaryContent>
            </ErrorBoundaryErrorCard>
          </ErrorBoundaryMaxWidthWrapper>
        </ErrorBoundaryContainer>
      )
    }

    return this.props.children
  }
}

export default withTranslation()(ErrorBoundary)